import * as React from "react";
import {useAppContext} from "../../../../hooks/useAppContext";
import {useMinimumQuantity} from "../../../../hooks/useMinimumQuantity";
import {useQuantity} from "../../../../hooks/useQuantity";
import {useScreenSizeDetector} from "../../../../hooks/useScreenSizeDetector";
import {Button, InputGroup} from "react-bootstrap";
import {Favorites} from "../favorites";
import {CommonCardLayout} from "./commonCardLayout";
import {MinimumQuantityNotice} from "./minimumQuantityNotice";
import {useAppDispatch} from "../../../../redux/stateHooks";
import {QuantityInputGroup} from "./quantityInputGroup";
import {useCreateItem} from "../../../../hooks/addToCart/useCreateItem";
import {useProductDetailsQuery} from "../../../../hooks/useProductDetailsQuery";
import {artworkOffCanvasActions} from "../../../../redux/slices/artworkOffCanvas";
import {useCustomerArtworkQuery} from "../../../../hooks/useCustomerArtworkQuery";
import {DesignServices} from "./designServices";
import {useAddToCartDisabled} from "../../../../hooks/addToCart/useAddToCartDisabled";

export const StandardProduct: React.FC = () => {
    const dispatch = useAppDispatch();
    const {isSmallScreenSize} = useScreenSizeDetector();
    const {createItem} = useCreateItem()
    const {model: {sku, artworkGuidelineTypePath}} = useProductDetailsQuery();
    const {model: {isTextOnly, isArtworkProduct}} = useCustomerArtworkQuery();
    const {productId} = useAppContext();
    const {minimumSaleQuantity} = useMinimumQuantity();
    const {quantity} = useQuantity();
    const addToCartDisabled = useAddToCartDisabled()

    return (
        <CommonCardLayout isSmallScreenSize={isSmallScreenSize}>
            {(isTextOnly || isArtworkProduct) &&
                <div className="mb-2 px-3" style={isSmallScreenSize ? {fontSize: '0.9em'} : {}}>
                    {(!isTextOnly) &&
                        <>
                            {isSmallScreenSize ?
                                <>Upload your artwork now, or later. </>
                                :
                                <>Upload your artwork now, or we'll send you a link to upload later.</>
                            }
                        </>
                    }
                    {artworkGuidelineTypePath && (
                        <a href={artworkGuidelineTypePath} target="_blank" className={'d-block'} tabIndex={0}
                           role="link" aria-label="View templates & guidelines">
                            View templates & guidelines
                        </a>
                    )}
                    {(isArtworkProduct && !isSmallScreenSize) && <div className="mt-2"><DesignServices location='page'/></div>}
                </div>
            }
            <InputGroup>
                {(isTextOnly || isArtworkProduct) ? '' : <QuantityInputGroup/>}
                <Button
                    disabled={addToCartDisabled}
                    variant="warning"
                    size="lg"
                    onClick={async () => {
                        if (isTextOnly || isArtworkProduct) {
                            dispatch(artworkOffCanvasActions.setShow(true))
                        } else {
                            await createItem()
                        }
                    }}
                    className={`flex-fill  ms-1 ${(isTextOnly || isArtworkProduct) ? 'artwork-offcanvas-btn' : 'add-to-cart-btn'}`}
                    data-ee-list={`ProductNew | Details`}
                    data-react="true"
                    data-item-id={productId}
                    data-quantity={quantity}
                    data-sku={sku}
                >
                    {(isTextOnly || isArtworkProduct) ? 'Get Started' : 'ADD TO CART'}
                </Button>
                <Favorites/>
            </InputGroup>
            {minimumSaleQuantity > 1 && <MinimumQuantityNotice minimumQuantity={minimumSaleQuantity}/>}
        </CommonCardLayout>
    );
};